import { FieldPrefix } from '../constants/fieldPrefixes';

import {
  AttachedDocumentsTabFields,
  BeneficiaryFields,
  FeeFields,
  ItemsTabFields,
  PackageFields,
  TreatmentFields,
} from './fieldEnums';

export const attachedDocumentConfigNames = {
  [AttachedDocumentsTabFields.code]: `${FieldPrefix.attachedDocument}code`,
  [AttachedDocumentsTabFields.referenceNumber]: `${FieldPrefix.attachedDocument}referenceNumber`,
  [AttachedDocumentsTabFields.attachmentDate]: `${FieldPrefix.attachedDocument}attachmentDate`,
  [AttachedDocumentsTabFields.fileUrl]: `${FieldPrefix.attachedDocument}fileUrl`,
};

export const feeConfigNames = {
  [FeeFields.paymentDate]: `${FieldPrefix.fee}paymentDate`,
  [FeeFields.receiptNumber]: `${FieldPrefix.fee}receiptNumber`,
};

export const itemConfigNames = {
  [ItemsTabFields.commodityCode]: `${FieldPrefix.item}commodityCode`,
  [ItemsTabFields.countryOfOriginCode]: `${FieldPrefix.item}countryOfOriginCode`,
  [ItemsTabFields.commercialDescription]: `${FieldPrefix.item}commercialDescription`,
  [ItemsTabFields.manufacturerName]: `${FieldPrefix.item}manufacturerName`,
  [ItemsTabFields.packageNumber]: `${FieldPrefix.item}packageNumber`,
  [ItemsTabFields.packageTypeCode]: `${FieldPrefix.item}packageTypeCode`,
  [ItemsTabFields.packageMark]: `${FieldPrefix.item}packageMark`,
  [ItemsTabFields.grossMass]: `${FieldPrefix.item}grossMass`,
  [ItemsTabFields.netMass]: `${FieldPrefix.item}netMass`,
  [ItemsTabFields.itemInvoiceAmountInForeignCurrency]: `${FieldPrefix.item}itemInvoiceAmountInForeignCurrency`,
  [ItemsTabFields.itemInvoiceAmountInNationalCurrency]: `${FieldPrefix.item}itemInvoiceAmountInNationalCurrency`,
  [ItemsTabFields.quotaType]: `${FieldPrefix.item}quotaType`,
  [ItemsTabFields.quotaType2]: `${FieldPrefix.item}quotaType2`,
  [ItemsTabFields.requestedAmount]: `${FieldPrefix.item}requestedAmount`,
  [ItemsTabFields.requestedAmount2]: `${FieldPrefix.item}requestedAmount2`,
  [ItemsTabFields.approvedAmount]: `${FieldPrefix.item}approvedAmount`,
  [ItemsTabFields.remainingAmount]: `${FieldPrefix.item}remainingAmount`,
  [ItemsTabFields.approvedAmount2]: `${FieldPrefix.item}approvedAmount2`,
  [ItemsTabFields.remainingAmount2]: `${FieldPrefix.item}remainingAmount2`,
  [ItemsTabFields.requestedUomCode]: `${FieldPrefix.item}requestedUomCode`,
  [ItemsTabFields.requestedUomCode2]: `${FieldPrefix.item}requestedUomCode2`,
  [ItemsTabFields.approvedUomCode]: `${FieldPrefix.item}approvedUomCode`,
  [ItemsTabFields.approvedUomCode2]: `${FieldPrefix.item}approvedUomCode2`,
};

export const packageConfigNames = {
  [PackageFields.packageCode]: `${FieldPrefix.packages}packageCode`,
  [PackageFields.packageQuantity]: `${FieldPrefix.packages}packageQuantity`,
  [PackageFields.numberOfNaturePackages]: `${FieldPrefix.packages}numberOfNaturePackages`,
};

export const treatmentConfigNames = {
  [TreatmentFields.validFrom]: `${FieldPrefix.treatments}validFrom`,
  [TreatmentFields.validTo]: `${FieldPrefix.treatments}validTo`,
  [TreatmentFields.typeCode]: `${FieldPrefix.treatments}typeCode`,
  [TreatmentFields.accuracyCode]: `${FieldPrefix.treatments}accuracyCode`,
  [TreatmentFields.chemicalCode]: `${FieldPrefix.treatments}chemicalCode`,
  [TreatmentFields.duration]: `${FieldPrefix.treatments}duration`,
  [TreatmentFields.temperature]: `${FieldPrefix.treatments}temperature`,
  [TreatmentFields.concentration]: `${FieldPrefix.treatments}concentration`,
  [TreatmentFields.additionalInformation]: `${FieldPrefix.treatments}additionalInformation`,
};

export const beneficiaryConfigNames = {
  [BeneficiaryFields.code]: `${FieldPrefix.beneficiary}code`,
  [BeneficiaryFields.email]: `${FieldPrefix.beneficiary}email`,
  [BeneficiaryFields.phoneNumber]: `${FieldPrefix.beneficiary}phoneNumber`,
};
